import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Scissors, Calculator, MessageSquare, Package, Link2, Settings, Copy, Check, UserX, Cake, ClipboardList } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const items = [
  { to: "/app/servicos", icon: Scissors, label: "Serviços", desc: "Cadastre e gerencie seus serviços", tid: "more-services" },
  { to: "/app/precificacao", icon: Calculator, label: "Precificação", desc: "Descubra o preço ideal por serviço", tid: "more-pricing" },
  { to: "/app/mensagens", icon: MessageSquare, label: "Mensagens", desc: "Modelos de WhatsApp", tid: "more-messages" },
  { to: "/app/reativacao", icon: UserX, label: "Clientes para reativar", desc: "Quem está há um tempo sem voltar", tid: "more-reactivation" },
  { to: "/app/aniversarios", icon: Cake, label: "Aniversários", desc: "Quem faz aniversário", tid: "more-birthdays" },
  { to: "/app/anamnese", icon: ClipboardList, label: "Anamnese", desc: "Ficha configurável para clientes", tid: "more-anamnesis" },
  { to: "/app/configuracoes", icon: Settings, label: "Configurações", desc: "Studio, pagamentos, sinal Pix", tid: "more-settings" },
];

export default function Mais() {
  const { studio } = useAuth();
  const [copied, setCopied] = useState(false);
  const bookingUrl = studio?.slug ? `${window.location.origin}/agendar/${studio.slug}` : "";
  const copy = async () => {
    try { await navigator.clipboard.writeText(bookingUrl); setCopied(true); toast.success("Link copiado!"); setTimeout(() => setCopied(false), 2000); }
    catch { toast.error("Não foi possível copiar."); }
  };

  return (
    <div className="space-y-5" data-testid="more-page">
      <h1 className="font-display text-2xl md:text-3xl font-bold text-[#27272A]">Mais</h1>

      {studio && (
        <div className="card-nc p-4">
          <div className="text-xs font-semibold uppercase tracking-wide text-[#682F3E] mb-1">Seu link público</div>
          <div className="flex items-center gap-2">
            <div className="flex-1 text-sm font-mono-brand text-[#27272A] truncate">{bookingUrl}</div>
            <button onClick={copy} data-testid="copy-link" className="btn-primary-nc py-2 px-3 text-xs">
              {copied ? <Check size={14} /> : <Copy size={14} />}
            </button>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map(i => (
          <Link key={i.to} to={i.to} data-testid={i.tid} className="card-nc p-4 flex items-center gap-3 hover:-translate-y-0.5">
            <div className="w-11 h-11 rounded-xl bg-[#F5ECE8] flex items-center justify-center text-[#682F3E]">
              <i.icon size={20} />
            </div>
            <div>
              <div className="font-semibold text-[#27272A]">{i.label}</div>
              <div className="text-xs text-[#71717A]">{i.desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
